import React, { useEffect, useRef, useState } from "react";

const FadeCard = ({ children, enableMobileFade = false }) => {
    const [opacity, setOpacity] = useState(1);
    const cardRef = useRef(null);

    useEffect(() => {
        const isMobile = window.matchMedia("(max-width: 768px)").matches;

        const rootMargin = isMobile
            ? `-${window.innerHeight * 0.2}px`
            : "0px"; 

        const threshold = isMobile
            ? Array.from({ length: 51 }, (_, i) => i / 100) 
            : Array.from({ length: 101 }, (_, i) => i / 100); 
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {

                    if (entry.intersectionRatio >= 0.2) {
                        setOpacity(1);
                    } else {
                        setOpacity(entry.intersectionRatio);
                    }
                });
            },
            {
                root: null,
                rootMargin: enableMobileFade ? rootMargin : "0px",
                threshold,
            }
        );

        if (cardRef.current) {
            observer.observe(cardRef.current);
        }

        return () => {
            if (cardRef.current) {
                observer.unobserve(cardRef.current);
            }
        };
    }, [enableMobileFade]);

    return (
        <div
            ref={cardRef}
            style={{
                opacity,
                transition: "opacity 0.3s ease",
                ...(window.matchMedia("(prefers-reduced-motion: reduce)").matches && {
                    transition: "none",
                }),
            }}
        >
            {children}
        </div>
    );
};

export default FadeCard;